import * as React from "react"
import { EmptyStateGraphic } from "@modules/ui/components/EmptyStateGraphic"
import { EmptyState } from "gatsby-interface"
import { organizationStatus as organizationStatusText } from "@modules/locales/default.js"
import { ServiceRouteLayout } from "./ServiceRouteLayout"

export function OrganizationIdle() {
  return (
    <ServiceRouteLayout>
      <EmptyState
        heading={organizationStatusText.headers.orgIsIdle}
        text={organizationStatusText.messages.idleStatusScreen}
        graphic={<EmptyStateGraphic />}
        variant="BORDERED"
      />
    </ServiceRouteLayout>
  )
}
